module.exports = __webpack_public_path__ + "static/TT1394_TW-MARK-D03_r1-clean-07ecee3f3b935660c817ca02cd105fc8.png";